module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/money-bill-wave.svg?d3a25f36fecf9eb7e40b993baa4014aa";